var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',[_vm._v("This is a dummy Vue component")]),_c('p',[_vm._v("If you see this component, Vue is working correctly")])])
}]

export { render, staticRenderFns }